module.exports = __webpack_public_path__ + "img/kn-logo.0c54bf4b.png";